import { Component, Input } from '@angular/core';
import {
    FEATURE_SCHEDULED_MAINTENANCE,
    hasAnyPermission,
    hasFeatureFlag,
    PersonsOrganisationDto,
    WorkTracker
} from '@flyfreely-portal-ui/flyfreely';
import { WorkspaceStateService } from '@flyfreely-portal-ui/workspace';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ResourceMaintenanceDataService } from './resource-maintenance-data.service';

@Component({
    selector: 'resource-maintenance',
    template: ` <ng-container screenAnalytics="resource-maintenance">
        <enhanced-help
            screenName="resource-maintenance"
            componentName="screen"
            [compact]="true"
        ></enhanced-help
        ><tabset>
            <tab heading="Configuration">
                <enhanced-help
                    screenName="resource-maintenance"
                    componentName="configuration"
                ></enhanced-help>
                <rpa-type-customisation
                    class="modal-body-content"
                    [organisation]="organisation"
                    [readOnly]="isReadOnlyAdmin"
                >
                </rpa-type-customisation>
            </tab>
            <tab
                *ngIf="hasScheduledMaintenance"
                heading="Maintenance Schedules"
            >
                <ng-template tabHeading>
                    <new-feature
                        type="BETA"
                        name="Maintenance Schedules"
                        description="Automatically take action when RPA are due for maintenance"
                    ></new-feature
                ></ng-template>
                <plan-highlight
                    [featureFlags]="maintenanceScheduleFeature"
                ></plan-highlight>
                <enhanced-help
                    screenName="resource-maintenance"
                    componentName="rpa-schedules"
                ></enhanced-help>
                <maintenance-schedule-list
                    class="modal-body-content"
                    [organisation]="organisation"
                    [readOnly]="isReadOnlyAdmin"
                ></maintenance-schedule-list>
            </tab>
            <tab *ngIf="true" heading="Battery Types">
                <battery-type-list
                    class="modal-body-content"
                    [organisation]="organisation"
                    [readOnly]="isReadOnlyAdmin"
                >
                </battery-type-list>
            </tab>
            <tab *ngIf="true" heading="RPA Types">
                <rpa-type-list
                    class="modal-body-content"
                    [organisation]="organisation"
                    [canEdit]="true"
                    [readOnly]="isReadOnlyAdmin"
                >
                </rpa-type-list>
            </tab> </tabset
    ></ng-container>`,
    providers: [WorkTracker, ResourceMaintenanceDataService]
})
export class ResourceMaintenance {
    @Input() organisation: PersonsOrganisationDto;

    hasScheduledMaintenance: boolean;
    maintenanceScheduleFeature = [FEATURE_SCHEDULED_MAINTENANCE];
    isReadOnlyAdmin = false;

    private ngUnsubscribe$ = new Subject<void>();

    constructor(private workspaceStateService: WorkspaceStateService) {}

    ngOnInit(): void {
        this.workspaceStateService.currentOrganisation$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(event => {
                if (event.type === 'organisation_loaded') {
                    this.organisation = event.organisation;

                    this.hasScheduledMaintenance = hasFeatureFlag(
                        this.organisation,
                        FEATURE_SCHEDULED_MAINTENANCE
                    );
                } else {
                    this.organisation = null;
                    this.hasScheduledMaintenance = false;
                }
                this.refreshPermissions();
            });
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    private refreshPermissions() {
        if (this.organisation == null) {
            this.isReadOnlyAdmin = true;
            return;
        }
        this.isReadOnlyAdmin =
            hasAnyPermission(
                this.organisation,
                PersonsOrganisationDto.Permissions.ORGANISATION_ADMIN_VIEW
            ) &&
            !hasAnyPermission(
                this.organisation,
                PersonsOrganisationDto.Permissions.ORGANISATION_EDIT
            );
    }
}
